import { defineStore } from 'pinia'

export const useCompanyStore = defineStore("company", {
  state: () => {
    return {
      jwt: null,
      agreement: false,
      list: [],
      searchObj: initSearchObj(),
      searchResignObj: initSearchResignObj(),
      toBeTerminateStaffList: []
    }
  },
  // getters: {
  //   getToBeTerminateStaffList: state => {
  //     return state.toBeTerminateStaffList
  //   },
  //   companyJWT: state => {
  //     return state.jwt
  //   },
  //   searchObj: state => {
  //     return state.searchObj
  //   },
  //   searchResignObj: state => {
  //     return state.searchResignObj
  //   }
  // },
  actions: {
    updateList(val) {
      this.list = val
    },
    updateToBeTerminateStaffList(val) {
      this.toBeTerminateStaffList = val
    },
    clearList() {
      this.list = []
    },
    clearToBeTerminateStaffList() {
      this.toBeTerminateStaffList = []
    },
    updateCompanyAgreement() {
      this.agreement = true
    },
    resetCompanyState() {
      this.jwt = null
      this.list = []
      this.toBeTerminateStaffList = []
      this.searchObj = initSearchObj()
      this.searchResignObj = initSearchResignObj()
      this.agreement = false
    },
    updateCompanyJWT(val) {
      this.jwt = val
    },
    updateSearchObj(val) {
      this.searchObj = val
    },
    updateSearchResignObj(val) {
      this.searchResignObj = val
    },
    clearSearchObj() {
      this.searchObj = initSearchObj()
    },
    clearSearchResignObj() {
      this.searchResignObj = initSearchResignObj()
    }
  },
  persist: true
});

function initSearchObj() {
  return {
    name: null,
    mobile: null,
    email: null,
    applicationType: null,
    status: null,
    createDateStart: null,
    createDateEnd: null
  }
}

function initSearchResignObj() {
  return {
    name: null,
    identityNumber: null,
    status: null,
    createDateStart: null,
    createDateEnd: null
  }
}
